import React, {PureComponent} from 'react';
import {Spin} from 'antd';


export default class Loading extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        const {
            list
        } = this.props;

        if(!list) {
            return (
                <Spin tip="در حال بارگزاری..."></Spin>
            );
        }else if(list && list.length == 0){
            return (
                false
            );
        }else
            return(null)
    }
}



